module.exports = __webpack_public_path__ + "static/media/GOLD COAST CITY.61236ceb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/council_areas/GOLD COAST CITY.svg
// module id = 546
// module chunks = 0